import { RouteConfig } from 'vue-router';

const Source = () => import('./views/source.vue');
const Card = () => import('./views/card.vue');


const routers: RouteConfig[] = [
    {
        path: 'source',
        component: Source,
    },
    {
        path: 'card',
        component: Card,
    },
    {
        path: '',
        redirect: 'source'
    },

]
export default routers;
